import { Box, ITheme, Typography, useTheme } from '@mui/material';
import { darken, lighten } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stages } from '../../models/Common';

export interface IStageGraph{
    data : Stages;
}

const StageGraph: React.FC<IStageGraph> = ({ data }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();

    const earlyRadius = !data.growth  && !data.late ? "4px" : "4px 0 0 4px";
    const growthRadius = !data.early && !data.late ? "4px" : (!data.early  ? "4px 0 0 4px" : (!data.late ? "0 4px 4px 0" : undefined));
    const lateRadius = !data.growth  && !data.early  ? "4px" : "0 4px 4px 0";

    return <Box display={"flex"} width={"100%"} gap={"1px"}>
        {data.early &&<Box display={'flex'} flexDirection={"column"} flexGrow={1} gap={"7px"}>
            <Box width={"100%"} height={"8px"}  sx={{ background: `linear-gradient(90deg, ${lighten(theme.palette.primary.dark, 0.4)} 0%, ${lighten(theme.palette.primary.dark, 0.2)} 100%)`}} borderRadius={earlyRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageEarly')}</Typography>
        </Box>}
        {data.growth &&<Box display={'flex'} flexDirection={"column"} flexGrow={1} gap={"7px"}>
            <Box width={"100%"} height={"8px"} sx={{ background: `linear-gradient(90deg, ${lighten(theme.palette.primary.dark, 0.2)} 0%, ${darken(theme.palette.primary.dark, 0.2)} 100%)`}} borderRadius={growthRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageGrowth')}</Typography>
        </Box>}
        {data.late &&<Box display={'flex'} flexDirection={"column"} flexGrow={1} gap={"7px"}>
            <Box width={"100%"} height={"8px"} sx={{ background: `linear-gradient(90deg, ${darken(theme.palette.primary.dark, 0.2)} 0%, ${darken(theme.palette.primary.dark, 0.4)} 100%)`}} borderRadius={lateRadius} />
            <Typography fontSize={"10px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.leo.tone3}>{t('PortfolioPageItemStageLate')}</Typography>
        </Box>}
    </Box>;

}
export default StageGraph;